import { AEMScenes } from '@as-react/common-types';
import { loadProductGroupFredhopperReducer } from '../../productGroupFredhopper/reducers/ProductGroupFredhopperReducer';
import deliveryPromiseSaga from '../../deliveryPromise/sagas/DeliveryPromiseSaga';
const loadProductGroupFredhopperModule = (initialData) => ({
    id: (initialData === null || initialData === void 0 ? void 0 : initialData.productGroupFredhopperId)
        ? `${AEMScenes.PRODUCT_GROUP_FREDHOPPER}_${initialData.productGroupFredhopperId}`
        : AEMScenes.PRODUCT_GROUP_FREDHOPPER,
    reducerMap: {
        productGroupFredhopper: loadProductGroupFredhopperReducer(initialData),
    },
    sagas: [deliveryPromiseSaga],
});
export default loadProductGroupFredhopperModule;
